"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSetting = getSetting;
exports.saveSetting = saveSetting;
exports.updateChartsImage = updateChartsImage;
var _request = _interopRequireDefault(require("@/utils/request"));
function getSetting(params) {
  return (0, _request.default)({
    url: '/portal/system/tenant/getSetting',
    method: 'get',
    params: params
  });
}
function saveSetting(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/saveSetting',
    method: 'post',
    data: data
  });
}
// 排行榜页面
function updateChartsImage(data) {
  return (0, _request.default)({
    url: '/portal/system/tenant/updateChartsImage',
    method: 'post',
    data: data
  });
}